import PropTypes from 'prop-types';
import React from 'react';

import { displayBuyerBidState } from '../../../core/api';
import { formalDate, fromNow } from '../../../core/date';
import BidSendMenu from './BidSendMenu';
import BidDetailPricing from './BidDetailPricing';
import BidDetailToolbar from './BidDetailToolbar';
import BidDetailNotes from './BidDetailNotes';
import HotelDetailWithToggle from '../../../components/HotelDetail/HotelDetailWithToggle';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';

class BidDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showDetail: false,
      is_rebid: false
    };
    this.remove = this.remove.bind(this);
    this.save = this.save.bind(this);
    this.openSend = this.openSend.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    if (this.props.bid.bidder_state == 'DD' && this.props.bid.buyer_state == 'DE') {
      this.setState({ is_rebid: true })
    }
  }
  save(e) {
    e.preventDefault();
    const state = e.currentTarget.getAttribute('data-item');
    const payload = {};
    payload.buyer_state = state;
    if (!this.props.isTourManager) {
      // Save buyer into the bid, if not the Tour Manager.
      payload.buyer = { id: this.props.user.id };
    }
    if (payload.buyer_state === 'ST') {
      // Special case for reopen...
      payload.bidder_state = 'UR';
    }
    this.props.editBid(this.props.bid.id, payload);
  }
  remove(e) {
    e.preventDefault();
    this.props.removeBid(this.props.bid.id);
    this.close();
  }
  close() {
    this.setState({ showModal: false });
  }
  openSend() {
    this.setState({ showModal: true });
  }
  render() {
    const { bid } = this.props;
    const hotel = bid.hotel;
    const distanceTo = { distance: bid.distance_to_venue, duration: bid.duration_to_venue };
    const bidState = displayBuyerBidState(bid.buyer_state, bid.bidder_state);
    const showBidder = bid.bidder && !this.props.isTourManager;
    const showRequestDetail = !this.props.isTourManager;
    return (
      <div className="container-fluid">
        <HotelDetailWithToggle distanceTo={distanceTo} hotel={hotel} />
        <hr style={{ margin: '30px 0 30px 0' }} />
        <div className="row">
          <div className="col-md-12">
            <h4>Bid Info ({bidState})</h4>
            <div>
              {showBidder && (
                <p>
                  {bid.bidder.first_name} {bid.bidder.last_name} ( {bid.bidder.email})
                </p>
              )}
              <p>
                Stay: {formalDate(bid.bidset.event.start)} - {formalDate(bid.bidset.event.end)}
              </p>
              <p>
                {bid.sent_on && <span>Sent: {fromNow(bid.sent_on)} </span>}
                {bid.replied_on && (
                  <span>Replied: {bid.replied_on && fromNow(bid.replied_on)} </span>
                )}
              </p>
            </div>
            <BidDetailPricing
              bid={this.props.bid}
              isTourManager={this.props.isTourManager}
              editBid={this.props.editBid}
            />
          </div>
          <div className="col-md-12">
            {showRequestDetail && (
              <div>
                {this.props.bid.bidset.event.group_note && (
                  <div>
                    <h4>Request Details</h4>
                    <br />
                    <p>{this.props.bid.bidset.event.group_note}</p>
                    <hr />
                  </div>
                )}
                {this.props.bid.bidset.event.group_note_json && (
                  <div>
                    <h4>Request Details</h4>
                    <br />
                    <DraftRenderer raw={this.props.bid.bidset.event.group_note_json} />
                    <hr />
                  </div>
                )}
              </div>
            )}
            <BidDetailNotes
              bid={this.props.bid}
              addBidNote={this.props.addBidNote}
              editBid={this.props.editBid}
            />
          </div>
        </div>
        {!this.props.readOnly && (
          <BidDetailToolbar
            bid={this.props.bid}
            open={this.open}
            remove={this.remove}
            save={this.save}
            openSend={this.openSend}
            isTourManager={this.props.isTourManager}
          />
        )}
        <BidSendMenu
          bid={this.props.bid}
          close={this.close}
          show={this.state.showModal}
          sendBid={this.props.sendBid}
          is_rebid={this.state.is_rebid}
        />
      </div>
    );
  }
}

BidDetail.propTypes = {
  bid: PropTypes.object.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default BidDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetail.js